namespace Areas.MyWorkflows.Action{
    "use strict";
    
    export function saveAndProcessRecord() {
        const form: DevExpress.ui.dxForm = Areas.getForm("WorkflowActionResponseForm"); 
        const data: any = form.option('formData');
        data.SubmittalResponse = getSubmittalResponse();

        const result: any = form.validate();

        if (result.isValid) {
            sendRequest("/MyWorkflows/Action/Complete", JSON.stringify(data), "Put");
        }
    }

    export function saveRecord() {
        //this saves but does NOT complete, i.e. does not continue and user can return
        //even if an action entered, it is overwritten to "Pending"

        const form: DevExpress.ui.dxForm = Areas.getForm("WorkflowActionResponseForm"); 
        const data: any = form.option('formData');
        data.SubmittalResponse = getSubmittalResponse();

        const result: any = form.validate();       

        if (result.isValid) {
            sendRequest("/MyWorkflows/Action/SaveWithoutComplete", JSON.stringify(data), "Put");
        }
    }

    export function gotoWorkflowFromForm() {
        const WorkflowId: any = Areas.getOptionFromForm("WorkflowDetailActionForm", "WorkflowId");

        if (WorkflowId != null) {
            location.href = `/MyWorkflows/View/Index/${WorkflowId}`;
        }
        else {
            DevExpress.ui.notify("Unable to find workflow record!", "warning", 2000);
        }
    }

    export function gotoEditWorkflowFromForm() {
        const WorkflowId: any = Areas.getOptionFromForm("WorkflowDetailActionForm", "WorkflowId");

        if (WorkflowId != null) {
            location.href = `/Workflows/Edit/Index/${WorkflowId}`;
        }
        else {
            DevExpress.ui.notify("Unable to find workflow record!", "warning", 2000);
        }
    }

    function getSubmittalResponse(): string {
        const responseList: DevExpress.ui.dxList = $("#ResponseList").dxList("instance");

        if (responseList) {
            const selectedItems = responseList.option("selectedItems");

            return $.map(selectedItems, function (item) { return item.value; }).join("|");
        }

        return null;
    }
}
